import { render } from "./Proveedor_Direccion.vue?vue&type=template&id=53144e11"
import script from "./Proveedor_Direccion.vue?vue&type=script&lang=js"
export * from "./Proveedor_Direccion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__